import { once as once$1 } from "../../function/once.mjs";
//#region src/compat/function/once.ts
function once(func) {
	return once$1(func);
}
//#endregion
export { once };
